module.exports = __webpack_public_path__ + "static/media/70.9010r.f7937cdb.pdf";